import http from '@/utils/http';

const baseUrl = '/sigef';

export default {
    consultarCpfCnpj(cpfCnpj) {
        return http.get({
            url: baseUrl + `/consulta/cpfcnpj/${cpfCnpj}`,
            lockScreen: true,
            lockMessage: 'Sigef: Consultando CPF/CNPJ'
        });
    },

    consultarINCRA(incra) {
        return http.get({
            url: baseUrl + `/consulta/incra/${incra}`,
            lockScreen: true,
            lockMessage: 'Sigef: Consultando número do INCRA'
        });
    },

    buscarGeometriaParcela(codigoParcela) {
        return http.get({
            url: baseUrl + `/${codigoParcela}/geometria`,
            lockScreen: true,
            lockMessage: 'Sigef: Buscando geometria da parcela'
        });
    }
};
